import pubsub from "@viewlift/pubsub";
var publishMonetisationcontinue = function (data) {
    // call when to start the payment process
    pubsub.publish('continue-monetisation', data);
};
var subscribeMonetisationcontinue = function (cb) {
    pubsub.subscribe('continue-monetisation', cb);
};
var publishProcessStripePayment = function (data) {
    // used to pass formRef (stripe form) refrence to the stripe file and start the stripe payment 
    pubsub.publish('process-stripe-payment', data);
};
var subscribeProcessStripePayment = function (cb) {
    pubsub.subscribe('process-stripe-payment', cb);
};
var publishMorePurchaseList = function (data) {
    pubsub.publish("subscription-modal", data);
};
var subscribePaymentStatusPopup = function (cb) {
    pubsub.subscribe('status-payment-modal', cb);
};
var publishPaymentStatusPopup = function (data) {
    pubsub.publish('status-payment-modal', data);
};
var subscribeBlockPreviewWall = function (cb) {
    pubsub.subscribe('block-preview-wall', cb);
};
var publishBlockPreviewWall = function (data) {
    pubsub.publish('block-preview-wall', data);
};
var subscribeSubscriptionStatusEvent = function (cb) {
    //sse event fro subscription status
    pubsub.subscribe('subscription-status-event', cb);
};
var publishTransactionStatus = function (data) {
    pubsub.publish("transaction-modal", data);
};
var subscribeTransactionStatus = function (cb) {
    pubsub.subscribe('transaction-modal', cb);
};
var publishDiscountData = function (data) {
    pubsub.publish("discount-data", data);
};
var subscribeDiscountData = function (cb) {
    pubsub.subscribe('discount-data', cb);
};
var publishRemoveOfferCode = function (data) {
    pubsub.publish("remove-offercode", data);
};
var subscribeRemoveOfferCode = function (cb) {
    pubsub.subscribe('remove-offercode', cb);
};
var publishApplyOfferCode = function (data) {
    pubsub.publish('apply-offercode', data);
};
var subscribeApplyOfferCode = function (cb) {
    pubsub.subscribe('apply-offercode', cb);
};
var publishUpgradeSubscription = function (data) {
    pubsub.publish("upgrade-subscription", data);
};
var subscribeUpgradeSubscription = function (cb) {
    pubsub.subscribe("upgrade-subscription", cb);
};
var publishUpgradeViewplansPopup = function (data) {
    pubsub.publish("upgrade-popup", data);
};
var subscribeUpgradeViewplansPopup = function (cb) {
    pubsub.subscribe("upgrade-popup", cb);
};
var publishReviewPurchasePopup = function (data) {
    pubsub.publish('purchase-details', data);
};
var subscribeReviewPurchasePopup = function (cb) {
    pubsub.subscribe('purchase-details', cb);
};
export { subscribeMonetisationcontinue, publishMonetisationcontinue, publishProcessStripePayment, subscribeProcessStripePayment, publishMorePurchaseList, subscribePaymentStatusPopup, publishPaymentStatusPopup, subscribeSubscriptionStatusEvent, publishTransactionStatus, subscribeTransactionStatus, publishDiscountData, subscribeDiscountData, subscribeRemoveOfferCode, publishRemoveOfferCode, publishApplyOfferCode, subscribeApplyOfferCode, subscribeBlockPreviewWall, publishBlockPreviewWall, publishUpgradeSubscription, subscribeUpgradeSubscription, subscribeUpgradeViewplansPopup, publishUpgradeViewplansPopup, publishReviewPurchasePopup, subscribeReviewPurchasePopup };
